import { ExchangePurchaseReport } from '../../../types';
import { commonColProps, DataGridHandler } from '../../DataGridFlexSales';

export interface ExchangePurchaseReportDataGridContext {
  t: (key: string | string[]) => string;
  country: string;
}

const initialContext: ExchangePurchaseReportDataGridContext = {
  t: () => '',
  country: '',
};

export default (locale: Locale) => {
  const handler = new DataGridHandler<
    ExchangePurchaseReport,
    ExchangePurchaseReportDataGridContext
  >(initialContext, locale);

  handler.addColumn({
    accessor: 'country',
    type: 'string',
    title: ({ t }) => t('table.columns.country'),
    ...commonColProps.country,
  });

  handler.addColumn({
    accessor: 'store',
    type: 'string',
    title: ({ t, country }) => t([`table.columns.${country}.store`, 'table.columns.store']),
  });

  handler.addColumn({
    accessor: 'franchiseType',
    type: 'string',
    title: ({ t }) => t(['toolbar.labels.franchiseType']),
    width: { px: 100, pt: 100 },
  });

  handler.addColumn({
    accessor: 'month',
    type: 'date',
    title: ({ t }) => t('table.columns.month'),
    ...commonColProps.month,
  });

  handler.addColumn({
    accessor: 'tenderName',
    type: 'string',
    title: ({ t }) => t('table.columns.tender_name'),
  });

  handler.addColumn({
    accessor: 'exchangePurchase',
    type: 'number',
    title: ({ t }) => t('accounting-info-report.exchange-purchase.columns.exchange-purchase'),
    total: { type: 'sum' },
  });

  return handler;
};
